import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';

import { IMainHeroProps } from '../components/main-hero/main-hero';

export class CareerHeroModel extends ContentItem {
  get backgroundAsset(): { url: string } {
    return get(this._config, 'elements.background_image.value[0]', '');
  }

  get title(): string {
    return get(this._config, 'elements.title_value.value', '');
  }

  get description(): string {
    return get(this._config, 'elements.description_value.value', '');
  }

  get contactApplyMail(): string {
    return get(this._config, 'elements.contact_apply_mail.value', '');
  }

  get buttonTextNoJob(): string {
    return get(this._config, 'elements.button_text_no_job.value', '');
  }

  get buttonTextJob(): string {
    return get(this._config, 'elements.button_text_job.value', '');
  }

  public static create(data: ICareerHero): IMainHeroProps {
    const {
      backgroundAsset,
      title,
      description,
      contactApplyMail,
      buttonTextNoJob,
      buttonTextJob
    } = new CareerHeroModel(data);
    return {
      backgroundAsset,
      title,
      description,
      contactApplyMail,
      buttonTextNoJob,
      buttonTextJob
    };
  }
}
